<div class="jumbotron text-center">
  <h1 class="display-4">Redirecting to Daimler ID.</h1>
</div>
